import styled from "styled-components";
import {responsive} from "../../../media-quries";
import {End} from "../home-header-section";
import PriceTile from "./price-tile";
import {kwPackages, singlePrice} from "../../../envs";
import { TbPigMoney } from "react-icons/tb";
import { LuDatabaseBackup } from "react-icons/lu";
import { TfiUnlock } from "react-icons/tfi";
import { PiUsersThree } from "react-icons/pi";
import tree4 from '../../../assets/tree4.webp';
import When from "./when/when";
import {Header, RingEmpty, RingFull} from "./landing.components";
import Opinions from "./opinions/opinions";
import Faq from "../../faq/faq";

const Container = styled.div`
  padding: 32px 0;
  position: relative;

  ${responsive.sm`
  margin-top: 40px;
  `}
`;

const TilesContainer = styled.div`
  display: flex;
  padding: 60px 0;
  flex-wrap: wrap;
  position: relative;
`;
const Tile = styled.div`
  align-items: flex-start;
  gap: 32px;
  display: flex;
  padding: 24px;
  flex-basis: 50%;
  transition: all 0.2s;
  max-width: 100%;
  
  &:hover {
    transform: scale(1.07);
  }
  
  ${responsive.md`
  flex-basis: 100%;
  `}

  ${responsive.sm`
  flex-basis: 100%;
  flex-direction: column;
  align-items: center;
  text-align: center;
  `}
`;
const TileTitle = styled.h4`
  font-weight: 900;
  font-size: 24px;
`;
const DividerContainer = styled.div`
  position: relative;
  height: 150px;
`;
const Separator = styled(End)`
  top: 0;
  clip-path: polygon(0 100%, 100% 50px, 100% 0, 0 0);
`;
const Prices = styled.div`
  background: linear-gradient(45deg, #6f1e3b, #8e264b);
  color: white;
  padding: 60px 40px;
  border-radius: 30px;
`;
const PricesTilesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 24px;
`;
const TileContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
const Ring1 = styled(RingEmpty)`
  width: 120px;
  height: 120px;
  top: -100px;
  left: -50px;
`;
const Ring2 = styled(RingEmpty)`
  width: 90px;
  height: 90px;
  bottom: 30px;
  right: -50px;

  ${responsive.sm`
    display: none;
  `}
`;
const Ring3 = styled(RingFull)`
  width: 40px;
  height: 40px;
  top: 0;
  left: 60px;
`;
const TreeWhyUs = styled.img`
  position: absolute;
  left: -200px;
  bottom: 40px;

  ${responsive.xxl`
    left: -300px;
  `}
`;

export const PricesSubpage = ({ title = 'Cennik' }) => {
    return <Prices>
        <Header>{title}</Header>
        <PricesTilesContainer>
            {kwPackages.map(({ count, price }) => <PriceTile price={price} count={count} />)}
        </PricesTilesContainer>
    </Prices>
}

function Landing() {
    return <Container>
        <Header>Dlaczego warto wybrać GeoKsiegi.pl</Header>
        <TilesContainer>
            <Tile>
                <TbPigMoney color="#bc436e" size={140} />
                <TileContent>
                    <TileTitle>
                        Najniższe ceny
                    </TileTitle>
                    <p>
                        Najniższe stawki za odsłonięcie numeru księgi wieczystej - to tylko <strong>{singlePrice} zł</strong> za odsłonięcie jednego numeru księgi wieczystej
                    </p>
                </TileContent>
            </Tile>
            <Tile>
                <LuDatabaseBackup color="#bc436e" size={140} />
                <TileContent>
                    <TileTitle>
                        Najaktualniejsza baza danych
                    </TileTitle>
                    <p>
                        Nasza baza zawiera ponad <strong>40 mln działek, 21 mln budynków i 7 mln lokali</strong>, i jest regularnie aktualizowana, co gwarantuje dostęp do najświeższych informacji
                    </p>
                </TileContent>
            </Tile>
            <Tile>
                <TfiUnlock color="#bc436e" size={140} />
                <TileContent>
                    <TileTitle>
                        Brak konieczności rejestracji
                    </TileTitle>
                    <p>
                        Uzyskaj numer księgi wieczystej szybko i wygodnie – w kilka minut bez konieczności zakładania konta
                    </p>
                </TileContent>
            </Tile>
            <Tile>
                <PiUsersThree color="#bc436e" size={140} />
                <TileContent>
                    <TileTitle>
                        Zaufanie klientów
                    </TileTitle>
                    <p>
                        <strong>Tysiące zadowolonych klientów</strong> potwierdza jakość naszych usług
                    </p>
                </TileContent>
            </Tile>
            <Ring1 />
            <Ring3/>
            <Ring2 />
            <TreeWhyUs src={tree4} />
        </TilesContainer>
        <DividerContainer>
            <Separator />
        </DividerContainer>
        <When />
        <PricesSubpage />
        <Opinions />
        <Faq />
    </Container>
}

export default Landing;
